import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import TableTop from "../../../Components/UI/TableTop";
import {
  useCPFContributionQuery,
  useInsertCPFContributionMutation,
  useUpdateCPFContributionMutation,
} from "../../../AppQuries/master/CpfContribution/contributions";
import Loader from "../../../feature-module/loader/loader";
import { useTableSearch } from "../../../core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import {
  useDeleteLocationMutation,
  useGetLocationQuery,
} from "AppQuries/master/Location/location";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import ReportTools from "Components/UI/ReportTools";
import { BackIcon } from "Components/UI/Icon/Icons";
import { Popconfirm, Switch } from "antd";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toast } from "core/Operations/toast";
const Location = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useGetLocationQuery({
    companyCode: userData?.companyCode,
    isTrue: true,
  });

  const { mutate: deleteLocation } = useDeleteLocationMutation();
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { mutate: addItem } = useInsertCPFContributionMutation();
  const { mutate: updateItem } = useUpdateCPFContributionMutation();
  const [selectedItem, setSelectedItem] = useState(null);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const ItemData = data?.map((d, _id) => ({
    id: _id + 1,
    ...d,
  }));

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      locationCode: id,
    };
    deleteLocation(payload, {
      onSuccess: (data) => {
        if (data) {
          toast.success("Location Deleted Successfully.");
          setSelectedItem(null);
          setShow(false);
          GetItems();
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const columns = [
    {
      title: "SNo",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
    },

    {
      title: "Location Name",
      dataIndex: "locationName",
      sorter: (a, b) => a.contributionName.length - b.contributionName.length,
    },

    {
      title: "Address1",
      dataIndex: "address1",
      sorter: (a, b) => a.address1.length - b.address1.length,
    },
    {
      title: "Address2",
      dataIndex: "address2",
      sorter: (a, b) => a.address2.length - b.address2.length,
    },
    {
      title: "Address3",
      dataIndex: "address3",
      sorter: (a, b) => a.address3.length - b.address3.length,
    },
    {
      title: "Country",
      dataIndex: "country",
      sorter: (a, b) => a.country.length - b.country.length,
    },
    {
      title: "ZipCode",
      dataIndex: "zipCode",
      sorter: (a, b) => a.zipCode.length - b.zipCode.length,
    },

    {
      title: "Status",
      dataIndex: "isActive",
      render: (text) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.master}
            accessCode={accessCodes.master_location}
            accessType="haveEdit"
          >
            <Link
              className="me-2 p-2"
              to={`${all_routes.master}${all_routes.location}${all_routes.location_edit}/${record.locationCode}`}
            >
              <Edit className="feather-edit" />
            </Link>
          </Can>
          <Can
            accessModule={accessCodes.master}
            accessCode={accessCodes.master_location}
            accessType="haveDelete"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
            >
              <Link className="me-2 p-2" to="#">
                <Popconfirm
                  title="Are you sure to Delete?"
                  onConfirm={() => deleteItemHandler(record.locationCode)}
                >
                  <Trash2 className="feather-delete" />
                </Popconfirm>
              </Link>
            </OverlayTrigger>
          </Can>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  useEffect(() => {
    if (isMount) GetItems();

    setIsMount(true);
  }, [showActiveOnly]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* <Breadcrumbs maintitle="Call History" subtitle="Manage your products" /> */}
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Company Location Details</h4>
                <h6>Manage Compnay Locations</h6>
              </div>
            </div>
            <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName="Company Location Master"
                isExcel={true}
                isPdf={true}
                pdfTheme="striped"
                refresh={GetItems}
              />
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <Can
                accessModule={accessCodes.master}
                accessCode={accessCodes.master_location}
                accessType="haveAdd"
              >
                <Link
                  to={`${all_routes.master}${all_routes.location}${all_routes.location_add}`}
                  className="btn btn-added"
                >
                  <PlusCircle className="me-2" />
                  Add New Location
                </Link>
              </Can>
              &nbsp;
              <Link to={`${all_routes.master}`} className="btn btn-secondary">
                <BackIcon className="me-2" />
                Back
              </Link>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={false}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="form-row row">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <Switch
                            checked={showActiveOnly}
                            checkedChildren="Show Active"
                            unCheckedChildren="Show All"
                            onChange={(checked) => setShowActiveOnly(checked)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Location;
